// extracted by mini-css-extract-plugin
export default {"dlReportSummary":"src-js-containers-reports-components-ReportSummary---dlReportSummary---Mij8H"};